var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "16px",
    viewBox: "0 0 22 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MVP---02.1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05-3-0-Board-Overview---Connected",
    transform: "translate(-1021.000000, -42.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(893.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logout",
    transform: "translate(127.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-10",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    points: "9 5 2 5 2 19 9 19"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-11",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    transform: "translate(18.000000, 12.000000) rotate(-45.000000) translate(-18.000000, -12.000000) ",
    points: "16 14 20 14 20 10"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 12,
    x2: 7.65685425,
    y2: 12,
    id: "Path-12",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.2b31f6ee.svg";
export { ForwardRef as ReactComponent };